export const sanitizePhoneNumber = (value = "", maxLength = 15) =>
  value.replace(/\D/g, "").slice(0, maxLength)
